import { useState } from 'react';
import BulkExportSelectFieldsModal from './SelectFieldsModal/SelectFieldsModal';
import BulkExportSuccessModal from './SuccessModal';

type BulkExportProps = {
  onClose: () => void;
  open: boolean;
  onProspectList: boolean;
  selectedCandidateIds: Set<number>;
};

const BulkExport: React.FC<BulkExportProps> = ({
  onClose,
  open,
  onProspectList,
  selectedCandidateIds,
}) => {
  const [success, setSuccess] = useState<boolean>(false);

  const onExport = () => {
    setSuccess(true);
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
    onClose();
  };

  if (success) {
    return <BulkExportSuccessModal open={open} onClose={handleCloseSuccess} />;
  }

  return (
    <BulkExportSelectFieldsModal
      open={open}
      onExport={onExport}
      onClose={onClose}
      onProspectList={onProspectList}
      selectedCandidateIds={selectedCandidateIds}
    />
  );
};

export default BulkExport;
